import SettingsCore from './settings-core'

export default class AccountSettingsBase extends SettingsCore {
  constructor (store, name) {
    super(store)
    this._name = name
  }

  // -----

  get requireConfirmedEmail () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._serverSettings[this._name].requireConfirmedEmail
  }

  get requireConfirmedPhoneNumber () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._serverSettings[this._name].requireConfirmedPhoneNumber
  }

  get registerViaUserNameEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.registerViaUserNameEnabled && this._serverSettings[this._name].registerViaUserNameEnabled
  }

  get registerViaEmailEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.registerViaEmailEnabled && this._serverSettings[this._name].registerViaEmailEnabled
  }

  get registerViaPhoneNumberEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.registerViaPhoneNumberEnabled && this._serverSettings[this._name].registerViaPhoneNumberEnabled
  }

  get registerViaOtpEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.registerViaOtpEnabled && this._serverSettings[this._name].registerViaOtpEnabled
  }

  // -----

  get loginViaUserNameEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.loginViaUserNameEnabled && this._serverSettings[this._name].loginViaUserNameEnabled
  }

  get loginViaEmailEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.loginViaEmailEnabled && this._serverSettings[this._name].loginViaEmailEnabled
  }

  get loginViaPhoneNumberEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.loginViaPhoneNumberEnabled && this._serverSettings[this._name].loginViaPhoneNumberEnabled
  }

  get loginViaOtpEnabled () {
    this._throwErrorIfNull(this._serverSettings[this._name], this._name)
    return this._clientSettings.loginViaOtpEnabled && this._serverSettings[this._name].loginViaOtpEnabled
  }

  // -----

  get registerViaPasswordEnabled () {
    return this.registerViaUserNameEnabled || this.registerViaEmailEnabled || this.registerViaPhoneNumberEnabled
  }

  // -----

  get loginViaPasswordEnabled () {
    return this.loginViaUserNameEnabled || this.loginViaEmailEnabled || this.loginViaPhoneNumberEnabled
  }

  // -----

  get resetPasswordEnabled () {
    return this._clientSettings.resetPasswordEnabled
  }

  // -----

  get showUserNameField () {
    return this.loginViaUserNameEnabled
  }

  get requireUserNameField () {
    return this.loginViaUserNameEnabled && !this.loginViaEmailEnabled && !this.loginViaPhoneNumberEnabled && !this.loginViaOtpEnabled
  }

  get requireEmailField () {
    return this.loginViaEmailEnabled && !this.loginViaUserNameEnabled && !this.loginViaPhoneNumberEnabled && !this.loginViaOtpEnabled
  }
  
  get requirePhoneNumberField () {
    return (this.loginViaPhoneNumberEnabled || this.loginViaOtpEnabled) && !this.loginViaUserNameEnabled && !this.loginViaEmailEnabled
  }
}
